import { APIClient, ApiQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { CreateLabel, GenerateTransactionLabel, Label, LabelListResponse, LabelQueryParams } from '@frontend/label/types';

export class LabelClient extends APIClient {
    public static readonly endpoint = '/label-api/v1';

    public static async fetchLabels(queryParams?: ApiQueryParams<LabelQueryParams>): Promise<LabelListResponse> {
        return await this.apiPaginated<LabelListResponse, LabelQueryParams>(`${this.endpoint}/labels`, queryParams);
    }

    public static async resolveLabels(ids: string[], field: keyof Label = 'id'): Promise<LabelListResponse> {
        const response = await this.post(`${this.endpoint}/labels-resolve`, { field, ids: ids });
        return await this.handleResponse<LabelListResponse>(response);
    }

    public static async deleteLabels(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/labels-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postLabel(accountId: string, body: CreateLabel): Promise<Label> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/labels`, body);
        return await this.handleResponse<Label>(response);
    }

    public static async fetchAccountLabel(accountId: string, labelId: string): Promise<Label> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/labels/${labelId}`);
        return await this.handleResponse<Label>(response);
    }

    public static async deleteLabel(accountId: string, labelId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/labels/${labelId}`);
        return await this.handleVoidResponse(response);
    }

    public static async fetchHtmlPreview(accountId: string, labelId: string): Promise<Blob> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/labels/${labelId}/preview-html`);
        return await this.handleBlobResponse(response);
    }

    public static async fetchPdfPreview(accountId: string, labelId: string): Promise<Blob> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/labels/${labelId}/preview-pdf`);
        return await this.handleBlobResponse(response);
    }

    public static async printLabel(accountId: string, labelId: string, body: { iot_id: string; quantity?: number; options?: any }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/labels/${labelId}/print`, body);
        return await this.handleVoidResponse(response);
    }

    //Transaction
    public static async generateTransactionLabel(accountId: string, transactionId: string, body: GenerateTransactionLabel): Promise<PaginatedResponse<Label>> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/labels`, body);
        return await this.handleResponse<PaginatedResponse<Label>>(response);
    }
}
